import React from 'react'
import BiStoreAlt from '@meronex/icons/bi/BiStoreAlt'

import {
  MessagesIcon,
  ActionsBlock
} from './styles'

import { getUtils } from './utils'

export const ActionsSection = (props) => {
  const {
    actionType,
    order,
    handleBusinessRedirect,
    businessData,
    unreadAlert,
    setOpenMessages,
    readMessages,
    setUnreadAlert,
    showPhone,
    showMessages
  } = props

  const { phoneIcon, chatIcon } = getUtils()

  const handleOpenMessages = (data) => {
    setOpenMessages(data)
    readMessages()
    if (order?.unread_count > 0) {
      data.business
        ? setUnreadAlert({ ...unreadAlert, business: false })
        : setUnreadAlert({ ...unreadAlert, driver: false })
    }
    window.scrollTo(0, 0)
  }

  return (
    <ActionsBlock actionType={actionType}>
      {actionType === 'business' && (
        <span className='business-icon'>
          <BiStoreAlt onClick={() => handleBusinessRedirect(businessData?.slug)} />
        </span>
      )}
      {showMessages && (
        <MessagesIcon onClick={() => handleOpenMessages({ driver: actionType === 'driver', business: actionType === 'business' })}>
          {chatIcon()}
        </MessagesIcon>
      )}
      {order?.[actionType] && (order?.[actionType]?.phone || order?.[actionType]?.cellphone) && showPhone && (
        <span onClick={() => window.open(`tel:${(order?.[actionType]?.phone || order?.[actionType]?.cellphone)}`)}>
          {phoneIcon()}
        </span>
      )}
    </ActionsBlock>
  )
}
